import React from 'react'
import { Container } from 'react-bootstrap'
import { isValidUrl } from '../../../common/urlValidation'
import { transformToSafeArray } from './aboutContent'

import './OAuth2AppsAboutTab.scss'

export interface OAuth2AppsAboutTabProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  description: Record<string, any>
}

const renderTextWithLinks = (text: string): React.ReactNode[] => {
  const matches = Array.from(text.matchAll(/\[(.*?)\]\s*\{(.*?)\}/g))
  const { nodes, lastIndex } = matches.reduce<{
    nodes: React.ReactNode[]
    lastIndex: number
  }>(
    (acc, match) => {
      const [fullMatch, label, url] = match
      const index = match.index ?? 0
      if (index > acc.lastIndex) {
        acc.nodes.push(text.slice(acc.lastIndex, index))
      }
      acc.nodes.push(
        isValidUrl(url) ? (
          <a key={index} className='help-article-link ms-1' href={url} target='_blank' rel='noopener noreferrer'>
            {label}
          </a>
        ) : (
          label
        ),
      )
      acc.lastIndex = index + fullMatch.length
      return acc
    },
    { nodes: [], lastIndex: 0 },
  )
  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex))
  }
  return nodes
}

export const OAuth2AppsAboutTab: React.FC<OAuth2AppsAboutTabProps> = ({ description }) => {
  const aboutList = transformToSafeArray(description?.about)
  const doList = transformToSafeArray(description?.do)
  const documentationList = transformToSafeArray(description?.documentation)

  return (
    <Container fluid>
      {aboutList.length > 0 && (
        <>
          <h4 className='mb-3'>About</h4>
          <div>
            {aboutList.map((item, idx) => (
              <div key={idx} className='d-flex my-4'>
                {item}
              </div>
            ))}
          </div>
        </>
      )}

      {doList.length > 0 && (
        <>
          <h4 className='mt-5 mb-3'>What you can do</h4>
          <div>
            {doList.map((item, idx) => (
              <div key={idx} className='d-flex gap-2 my-1'>
                <i className='bi bi-check2 zocks-text-success' />
                {item}
              </div>
            ))}
          </div>
        </>
      )}

      {documentationList.length > 0 && (
        <>
          <h4 className='mt-5 mb-3'>View help documentation</h4>
          <div>
            {documentationList.map((item, idx) => (
              <div key={idx} className='d-flex my-4'>
                {renderTextWithLinks(item)}
              </div>
            ))}
          </div>
        </>
      )}
    </Container>
  )
}
